export const ASSET_PREFIX = 'asset-';
export const ORGANISATION_PREFIX = 'organisations';
export const THUMBNAIL_PREFIX = 'thumbnail-';
export const ASSET_FILE_PREFIX = 'assetfile-';
export const FILE_PREFIX = 'file-';

export const DELAY_SYNC_TIME = 600000;
export const CHECK_OFFLINE_DELAY = 2500;
export const SYNC_LOOP_DELAY_MS = 2000;
export const SYNC_DELAY_NORMAL_MS = 600000;
export const SYNC_DELAY_CHANGES_MS = 10000;
export const SYNC_DELAY_NETWORK_ERROR_MS = 60000;
export const SYNC_DELAY_401_ERROR_MS = 60000;

export const DELAY_FAILED_ERRORS_UPLOAD_MS = 60000;
export const CHECK_FOR_APP_UPDATE_MS = 600000;
export const DELAY_APP_UPDATE_MS = 600000;
